import {
  types,
  GroupsActionsType,
  IGroupsDetailed,
} from '../types/groupsDetailed'

export const initialState: IGroupsDetailed = {
  isLoading: false,
  isLoaded: false,
  list: [],
}

export const groupsDetailed = (
  state = initialState,
  action: GroupsActionsType
): IGroupsDetailed => {
  switch (action.type) {
    case types.GET_GROUPS_DETAILED__STARTED:
      return { ...state, isLoading: true }
    case types.GET_GROUPS_DETAILED__SUCCESS:
    case types.UPDATE_GROUPS_DETAILED:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        list: action.list || [],
      }
    case types.GET_GROUPS_DETAILED__FAILURE:
      return { ...state, isLoading: false, isLoaded: true }
    default:
      return state
  }
}
